// extracted by mini-css-extract-plugin
export var container = "BlockGrid-module--container--52bfc";
export var page_grid = "BlockGrid-module--page_grid--2fac8";
export var transparent = "BlockGrid-module--transparent--161b4";